<!-- Breadcrumb Section -->
<div class="bg-header" *ngIf="configurationService.isTabletOrLarger$ | async">
  <div class="container-header">
    <div
      *ngIf="activeTab != 'planning' && activeTab != 'members'"
      class="h2"
      routeDirective
    >
      <a
        [routerLink]="[appRoutesNS.Competitions.COMPETITIONS]"
        class="px-2 px-2 d-inline-block"
        ><i
          role="img"
          class="fa fa-arrow-left back-arrow"
          attr.aria-label="{{ 'general.back' | translate }}"
        ></i
      ></a>

      {{ 'general.back' | translate }}
    </div>
  </div>
</div>
<!-- End Breadcrumb Section -->
<div class="container-lg main-container">
  <!-- Step -->

  <ul class="step step-md step step-inline mb-3 mb-md-5">
    <li class="step-item" [ngClass]="{ active: activeTab === 'teamDetails' }">
      <div class="step-content-wrapper">
        <span class="step-icon">1</span>
        <div class="step-content">
          <span class="h5 mb-0">
            {{ 'competitionModule.teamDetails' | translate }}
          </span>
        </div>
      </div>
    </li>

    <li class="step-item" [ngClass]="{ active: activeTab === 'planning' }">
      <div class="step-content-wrapper">
        <span class="step-icon">2</span>
        <div class="step-content">
          <span class="h5 mb-0">
            {{ 'competitionModule.planning' | translate }}
          </span>
        </div>
      </div>
    </li>

    <li class="step-item" [ngClass]="{ active: activeTab === 'members' }">
      <div class="step-content-wrapper">
        <span class="step-icon">3</span>
        <div class="step-content">
          <span class="h5 mb-0">
            {{ 'memberModule.members' | translate }}
          </span>
        </div>
      </div>
    </li>
  </ul>
  <!-- End Step -->
  <competition-team-create-form
    *ngIf="activeTab == 'teamDetails'"
    [team]="team$ | async"
    [showSubmitButton]="false"
    (onSubmit)="onTeamDetailsFormSubmit($event)"
  ></competition-team-create-form>

  <competition-team-planning-tab
    *ngIf="activeTab == 'planning'"
    (onSubmit)="onPlanningTabSubmit($event)"
  ></competition-team-planning-tab>

  <competition-team-members-tab
    *ngIf="activeTab == 'members'"
  ></competition-team-members-tab>

  <div
    class="d-flex mt-3"
    [ngClass]="{
      'justify-content-between': activeTab != 'teamDetails',
      'justify-content-end': activeTab === 'teamDetails'
    }"
  >
    <button
      [hidden]="activeTab == 'teamDetails'"
      type="button"
      class="btn btn-soft-primary"
      (click)="onClickBackButton()"
    >
      {{ 'general.back' | translate }}
    </button>

    <button type="button" class="btn btn-primary" (click)="onClickNextButton()">
      {{
        activeTab == 'members'
          ? (invitedPlayers$ | async)?.length ||
            (invitedStaffMembers$ | async)?.length
            ? ('competitionModule.registerTeamAndSendInvitations' | translate)
            : ('competitionModule.registerTeam' | translate)
          : ('general.next' | translate)
      }}
    </button>
  </div>
</div>
